<div class="checkins-list" *ngIf="checkins">

    <!-- Stress: 0-100 score + word label (UNIVAPLAT-2359 bands); unchecked when this
         item was skipped on an otherwise-completed check-in -->
    <div class="checkin-row" *ngIf="checkins.stress">
        <i class="bi checkin-row__icon"
           [class.bi-check-circle-fill]="stressAnswered"
           [class.bi-circle]="!stressAnswered"
           [class.checkin-row__icon--unanswered]="!stressAnswered"
           aria-hidden="true"></i>
        <span class="checkin-label">Stress</span>
        <div class="checkin-values">
            <ng-container *ngIf="checkins.stress.value !== null">
                <span class="stress-score">{{ checkins.stress.value }}</span>
                <span class="chip stress-label-chip"
                      [ngClass]="stressBandClass"
                      *ngIf="checkins.stress.label">{{ checkins.stress.label }}</span>
            </ng-container>
            <span class="visually-hidden" *ngIf="!stressAnswered">not completed</span>
        </div>
    </div>

    <!-- Mood: core emotion chip, optional finer word (legacy YEM days: core only);
         unchecked when no mood check was completed that day (core null — see moodAnswered) -->
    <div class="checkin-row" *ngIf="checkins.mood">
        <i class="bi checkin-row__icon"
           [class.bi-check-circle-fill]="moodAnswered"
           [class.bi-circle]="!moodAnswered"
           [class.checkin-row__icon--unanswered]="!moodAnswered"
           aria-hidden="true"></i>
        <span class="checkin-label">Mood</span>
        <div class="checkin-values">
            <span class="chip mood-chip" [ngClass]="moodColourClass" *ngIf="checkins.mood.core !== null">
                <span class="mood-chip__core">{{ checkins.mood.core }}</span>
                <span class="mood-chip__fine" *ngIf="checkins.mood.fine">· {{ checkins.mood.fine }}</span>
            </span>
            <span class="visually-hidden" *ngIf="!moodAnswered">not completed</span>
        </div>
    </div>

    <!-- Sleep: felt-state chip + patient-only yellow factor pills; unchecked when no
         sleep check was completed that day (feltState null — see sleepAnswered) -->
    <div class="checkin-row" *ngIf="checkins.sleep">
        <i class="bi checkin-row__icon"
           [class.bi-check-circle-fill]="sleepAnswered"
           [class.bi-circle]="!sleepAnswered"
           [class.checkin-row__icon--unanswered]="!sleepAnswered"
           aria-hidden="true"></i>
        <span class="checkin-label">Sleep</span>
        <div class="checkin-values">
            <span class="chip sleep-felt-chip"
                  [ngClass]="sleepColourClass"
                  *ngIf="checkins.sleep.feltState !== null">{{ checkins.sleep.feltState }}</span>
            <span class="chip sleep-factor-pill yellow"
                  *ngFor="let factor of sleepFactorPills; trackBy: trackByIndex">{{ factor }}</span>
            <span class="visually-hidden" *ngIf="!sleepAnswered">not completed</span>
        </div>
    </div>

    <!-- Contributing factors: patient variant only; always shown, same answered/unanswered
         treatment as Stress/Mood/Sleep (see contributingFactorsAnswered) -->
    <div class="checkin-row" *ngIf="isPatient">
        <i class="bi checkin-row__icon"
           [class.bi-check-circle-fill]="contributingFactorsAnswered"
           [class.bi-circle]="!contributingFactorsAnswered"
           [class.checkin-row__icon--unanswered]="!contributingFactorsAnswered"
           aria-hidden="true"></i>
        <span class="checkin-label">Contributing factors</span>
        <div class="checkin-values">
            <span class="chip contributing-factor-chip grey"
                  *ngFor="let factor of contributingFactorChips; trackBy: trackByIndex">{{ factor }}</span>
            <span class="visually-hidden" *ngIf="!contributingFactorsAnswered">not completed</span>
        </div>
    </div>

</div>
